<template>
  <div class="storeAdd">
    <div class="indexBar-box">
      <van-index-bar :index-list="goodsGroupNameList" ref="vanIndexBar" @select="selectFun" @change="changeFun">
        <van-checkbox-group v-model="result" @change="checkboxChange">
          <div v-for="(item, index) in certificateList" :key="index">
            <van-index-anchor :index="item.goodsGroupName" :class="{ 'active-color': isActive == item.goodsGroupName }">{{item.goodsGroupName}}</van-index-anchor>
            <van-cell v-for="tt in item.acctGoodsVO" :key="tt.goodsId">
              <div class="checkbox-item">
                <van-checkbox icon-size="16px" :name="tt.goodsId" shape="square" ref="checkboxes">{{tt.goodsName}}</van-checkbox>
                <van-stepper v-model="tt.number" integer button-size="22px" max="9999" input-width="42px" />
              </div>
            </van-cell>
          </div>
        </van-checkbox-group>
      </van-index-bar>
    </div>
    <div>
      <van-row class="btnRow">
        <van-col span="24" class="centerText confirmText" @click.native="sureFun">选好了</van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Row, Col, Cell, IndexBar, IndexAnchor, Checkbox, CheckboxGroup, Stepper, Toast } from "vant";

Vue.use(Row)
  .use(Col)
  .use(Cell)
  .use(IndexBar)
  .use(IndexAnchor)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Stepper)
  .use(Toast)

export default {
  name: "storeAdd",
  components: {},
  data() {
    return {
      isActive: '',
      result: [],
      goodsGroupNameList: [],
      certificateList: []
    };
  },

  methods: {
    selectFun (name) { // e是类别名称
      this.isActive = name
      let ind = 0
      this.goodsGroupNameList.forEach((item, index) => {
        if (item == name) ind = index
      })
      let elList = document.getElementsByClassName('van-index-bar__index')
      for (let i = 0; i < elList.length; i++) {
        if (i == ind) {
          document.getElementsByClassName('van-index-bar__index')[i].className = "van-index-bar__index van-index-bar__index--active"
        } else {
          document.getElementsByClassName('van-index-bar__index')[i].className = "van-index-bar__index"
        }
      }
    },
    changeFun (index) {
      console.log(index)
      this.certificateList.forEach((item, ind) => {
        if (index == ind) {
          this.selectFun(item.goodsGroupName)
        }
      })
    },
    // 获取材料及其分类列表
    getGoodsList () {
      let storeGoodsList = localStorage.getItem("storeGoodsList");
      if (storeGoodsList) {
        storeGoodsList = JSON.parse(storeGoodsList)
      }
      let params = {
        accCompanyId: this.$store.state.acctCompanyInfo.accCompanyId
      }
      this.$http
        .post("/mini/user/goods/group/queryGoodsForVoucher", params)
        .then(res => {
          if (res.data.code == 200) {
            let certificateList  = res.data.data;
            certificateList.forEach((item) => {
              this.goodsGroupNameList.push(item.goodsGroupName)
              item.acctGoodsVO.forEach((tt) => {
                if (!tt.goodsRemarks) tt.goodsRemarks = ''
                tt.checked = false
                if (!tt.number) tt.number = 1
              })
            })
            if (storeGoodsList && storeGoodsList.length > 0) {
              this.certificateList = certificateList
              storeGoodsList.forEach((item) => {
                certificateList.forEach((ite, index) => {
                  ite.acctGoodsVO.forEach((tt, ind) => {
                    if (tt.goodsId === item.goodsId) {
                      this.certificateList[index].acctGoodsVO[ind] = item
                    }
                  })
                })
              })
            }
            this.certificateList = certificateList
            this.$nextTick(() => { // 默认选中上次选中的记录
              this.toggle()
            })
          }
        })
        .catch(() => {
          Toast("服务器错误，请联系账无忧解决!");
        });
    },
    checkboxChange () {
      console.log(this.result)
      let resultList = this.result
      let certificateList = this.certificateList

      // 取消所有选中
      if (resultList.length === 0) {
        certificateList.forEach((item) => {
          item.acctGoodsVO.forEach((tt) => {
            tt.checked = false
            tt.number = 1
          })
        })
      }
      certificateList.forEach((item) => {
        item.acctGoodsVO.forEach((ite) => {
          resultList.forEach((tt) => {
            if (tt == ite.goodsId) {
              ite.checked = true
            }
          })
        })
      })
    },
    // 初始化默认选中
    toggle() {
      let certificateList = this.certificateList

      // 获取列表后处理
      let itemlist = []
      certificateList.forEach((item) => {
        itemlist = itemlist.concat(item.acctGoodsVO)
      })
      itemlist.forEach((item, index) => {
        if (item.checked) {
          this.$refs.checkboxes[index].toggle();
        }
      })
    },
    sureFun () {
      console.log(this.result)
      let certificateList = this.certificateList
      let result = this.result
      if (result.length == 0) {
        localStorage.removeItem("storeGoodsList");
      } else {
        // 获取列表后处理
        let itemlist = []
        certificateList.forEach((item) => {
          itemlist = itemlist.concat(item.acctGoodsVO)
        })

        // 获取列表后处理
        let storeGoodsList = []
        result.forEach((item) => {
          itemlist.forEach((tt) => {
            if (item === tt.goodsId) {
              tt.goodsRemarks = ''
              storeGoodsList.push(tt)
            }
          })
        })

        // 与本地保存的对比-使用本地保存的备注
        let lsGoodsList = JSON.parse(localStorage.getItem("storeGoodsList"));
        if (lsGoodsList && lsGoodsList.length > 0) {
          storeGoodsList.forEach((item) => {
            lsGoodsList.forEach((tt) => {
              if (item.goodsId === tt.goodsId) {
                item.goodsRemarks = tt.goodsRemarks
              }
            })
          })
        }

        localStorage.setItem("storeGoodsList", JSON.stringify(storeGoodsList));
      }
      this.$router.go(-1);
    }
  },
  mounted: function() {
    // 获取本地保存的上次选中记录
    this.getGoodsList()
    //滚动条置顶
    document.documentElement.scrollTop = document.body.scrollTop = 0;
  }
};
</script>

<style type="text/css" lang="stylus" scoped>
.storeAdd {
    position: relative;
    height: 100%;
    background: #ffffff;
    .btnRow {
      text-align: center;
      color: #1FADF6;
      background-color: #ffffff;
      border-top: 1px solid #f0f2f2;
      position: fixed;
      width: 100%;
      bottom: 0;
      left: 0;
      font-size: 0.17rem;
      box-sizing: border-box;
      font-weight: 500;
      line-height: 0.52rem;
      z-index: 9999;
    }

    .checkbox-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: row;
      height: 0.36rem;
    }

    .btnRow.disabled {
      color: #B4BEC7;
    }
    .confirmText {
      color: #fff;
      height: 0.52rem;
      line-height: 0.52rem;
      background: #1fadf6;
    }
}
</style>
<style>
.storeAdd .van-index-bar {
  position: relative;
  padding-left: 0.9rem;
  padding-bottom: 0.53rem;
}
.storeAdd .van-index-bar__sidebar {
  left: 0;
  right: 100%;
  background:#f0f2f2;
  width: 0.9rem;
  height: 100%;
}
.storeAdd .van-index-bar__index {
  line-height: 0.44rem;
  font-size: 0.15rem;
  color: #323233 !important;
}
.storeAdd .van-index-bar__index--active {
  font-weight: 500;
  border-color: #1390ff;
  background-color: #fff;
  border-left: 3px solid;
  color:#1390ff !important;
}
.storeAdd .van-index-anchor {
  color: rgb(180, 190, 199) !important;
  font-size: 0.12rem;
  line-height: 0.48rem;
}
.storeAdd .active-color .van-index-anchor {
  color: #1390ff !important;
  height: 0.48rem;
}
.storeAdd .active-color .van-index-anchor--sticky {
  background: #ffffff;
  color:#1390ff !important;
}
.storeAdd .van-stepper__minus,
.storeAdd .van-stepper__plus {
  border-radius: 0 2px 2px 0;
}
</style>

